import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { FC, ReactNode } from "react";
import Typography from "../Typography";

export type FAQAccordionItem = {
  question: string;
  answer: ReactNode;
};

type FAQAccordionProps = {
  sectionTitle?: ReactNode;
  faqs: FAQAccordionItem[];
};

const FAQAccordion: FC<FAQAccordionProps> = ({
  sectionTitle = "Frequently asked questions",
  faqs,
}) => {
  return (
    <section className="max-w-5xl px-3 md:px-12 mx-auto my-32 md:my-48">
      <Typography variant="h2" component="h2" className="text-center">
        {sectionTitle}
      </Typography>
      <div className="mt-16 font-display w-full flex flex-col text-left items-stretch justify-start gap-4">
        {faqs.map((faq, index) => (
          <details
            key={faq.question}
            open={index === 0}
            className="font-light list-none group open:bg-slate-100 rounded-2xl"
          >
            <summary className="text-xl font-normal list-none flex items-center justify-stretch hover:bg-slate-100 p-5 rounded-2xl cursor-pointer">
              <Typography
                variant="subtitle1"
                className="text-slate-900"
                component="span"
              >
                {faq.question}
              </Typography>
              <ChevronDownIcon className="w-6 h-6 ml-auto group-open:rotate-180 shrink-0 text-slate-500 transition-transform" />
            </summary>
            <div className="px-5 pb-5">
              <Typography variant="body2" className="text-slate-600">
                {faq.answer}
              </Typography>
            </div>
          </details>
        ))}
      </div>
    </section>
  );
};

export default FAQAccordion;
